// extracted by mini-css-extract-plugin
module.exports = {"tinkoffBtn":"TinkoffBtnView__tinkoffBtn___28sKw","a":"TinkoffBtnView__a___W44Bg"};